import type {NavigationDrawerMenuItem} from '@refinio/one.ui/lib/ui/components/menu/NavigationDrawer.js';

import i18n from '@/i18n.js';

/**
 * Returns the list of the menu items
 */
export function getLeuteMenuItems(): NavigationDrawerMenuItem[] {
    return [
        {
            name: i18n.t('menu.home'),
            path: '/home'
        },
        {
            name: i18n.t('menu.contacts'),
            path: '/contacts'
        },
        {
            name: i18n.t('menu.everyone'),
            path: '/chat/EveryoneTopic'
        },
        {
            name: i18n.t('menu.glue'),
            path: '/chat/GlueOneTopic'
        },
        {
            name: i18n.t('menu.patients'),
            path: '/patients'
        },
        {
            name: i18n.t('menu.questionnaires.schmerzerfassungsQuestionnaire'),
            subItems: [
                {
                    name: i18n.t('menu.questionnaires.schmerzerfassungsQuestionnaire_Num'),
                    path: '/questionnaire/new?questionnaires=Schmerzerfassung_NumAssessment'
                },
                {
                    name: i18n.t('menu.questionnaires.schmerzerfassungsQuestionnaire_Face'),
                    path: '/questionnaire/new?questionnaires=Schmerzerfassung_FaceAssessment'
                },
                {
                    name: i18n.t('menu.questionnaires.schmerzerfassungsQuestionnaire_Verbal'),
                    path: '/questionnaire/new?questionnaires=Schmerzerfassung_VerbalAssessment'
                }
            ]
        },
        {
            name: i18n.t('menu.questionnaires.title'),
            subItems: [
                {
                    name: i18n.t('menu.questionnaires.example'),
                    path: '/questionnaire/new?questionnaires=Example%20Questionnaire'
                },
                {
                    name: i18n.t('menu.questionnaires.onBoarding'),
                    path: '/questionnaire/new?questionnaires=onboarding_patient'
                },
                {
                    name: i18n.t('menu.questionnaires.generalQuestionnaireShort'),
                    path: '/questionnaire/new?questionnaires=General%20Questionnaire%20%28short%29'
                },
                {
                    name: i18n.t('menu.questionnaires.whpQuestionnaire'),
                    path: '/questionnaire/new?questionnaires=WHP%20Follow%20Up%20Visit%20From%201'
                },
                {
                    name: i18n.t('menu.questionnaires.lftStudyQuestionnaire'),
                    path: '/questionnaire/new?questionnaires=LFT%20Study%20Questionnaire'
                },
                {
                    name: i18n.t('menu.questionnaires.CervicalCancerScreeningAndTreatmentRegister'),
                    path: '/questionnaire/new?questionnaires=cervical_cancer_screeninc_and_treatment_register'
                },
                {
                    name: i18n.t('menu.questionnaires.resclue'),
                    path: '/questionnaire/new?questionnaires=resclue'
                },
                {
                    name: i18n.t('menu.questionnaires.ifcpc'),
                    path: '/questionnaire/new?questionnaires=2011_IFCPC_colposcopic_terminology_cervix'
                },
                {
                    name: i18n.t('menu.questionnaires.colposcopy_exam_record'),
                    path: '/questionnaire/new?questionnaires=colposcopy_examination_record'
                },
                {
                    name: i18n.t('menu.questionnaires.EQ5D3L'),
                    path: '/questionnaire/EQ5D3LQuestionnaire/new'
                },
                {
                    name: i18n.t('menu.questionnaires.generalFeedback'),
                    path: '/questionnaire/new?questionnaires=general_feedback_edda'
                },
                {
                    name: i18n.t('menu.questionnaires.specificFeedback'),
                    path: '/questionnaire/new?questionnaires=specific_feedback_edda'
                }
            ]
        },
        {
            name: i18n.t('menu.ecpire'),
            path: '/ecpire'
        },
        {
            name: i18n.t('menu.journal'),
            path: '/journal'
        },
        {
            name: i18n.t('menu.calendar'),
            path: '/calendar'
        },
        {
            name: i18n.t('menu.connections'),
            path: '/connections'
        },
        {
            name: i18n.t('menu.settings'),
            path: '/settings'
        },
        {
            name: i18n.t('menu.iom_view'),
            path: '/iom'
        },
        {
            name: i18n.t('menu.downloads'),
            path: '/downloads'
        }
    ];
}
